<template>
  <div class="class-item" @click="$emit('click')" :class="{ completed: item.classStatus === 1 }">
    <div class="item-name van-ellipsis" :class="{'choose-mode': isChooseMode}">
      <van-icon
        v-if="showTag"
        name="checked"
        size="var(--fs-ex1)"
        class="tag"
        color="var(--c1)"
      />
      <van-icon v-else-if="isChooseMode" class="tag" name="circle" size="var(--fs-ex1)" color="var(--g5)" />
      {{ item.className }}

    </div>
    <div class="item-content">
      <div class="item-dimension van-ellipsis">
        <span v-if="item.curriculumName" class="cname"
          >{{ item.curriculumName }}</span
        >
      </div>
      <div class="item-info">
        <div class="info van-ellipsis">{{ item.campusName }}</div>
        <div class="info van-ellipsis" v-if="item.attendClassTeachers && item.attendClassTeachers.filter(v=>v.teacherRule === 0).length>0">
          {{ item.attendClassTeachers.filter(v=>v.teacherRule === 0).map(v=>v.teacherName).join('、') }}
        </div>
      </div>
      <div class="flex-between">
        <span>
          <van-icon
            class-prefix="vxs-icon"
            name="zaiduxueyuan"
            size="16"
            color="var(--g6)"
          /><span class="item-num"
            >{{ item.currentClassNum }}/{{ item.fullClassNum }}</span
          >
        </span>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import x3TagDay  from '@x3/common/tag/x3-tag-day.vue'
export default {
  name: "class-item",
  components: {
    x3TagDay,
  }, 
  props: {
    item: {
      default: {},
      type: Object,
    },
    showTag: {
      default: false,
      type: Boolean,
    },
    isChooseMode: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.class-item {
  margin: calc(var(--gap) * 12) calc(var(--gap) * 16) 0;
  border-radius: var(--radius-sm);
  background: var(--white);
  .item-name {
    position: relative;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    font-weight: var(--bold);
    background-color: rgba(var(--g2-rgb), 0.3);
    &.choose-mode{
      padding-left: calc(var(--gap) * 36);
    }
    .tag {
      position: absolute;
      left: calc(var(--gap) * 12);
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .item-content {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    .item-info {
      display: flex;
      align-items: center;
    }
    .item-dimension,
    .item-info {
      color: var(--g6);
      font-size: var(--fs-md);
      line-height: var(--lh-md);    
    }
    .item-dimension {
      margin-bottom: calc(var(--gap) * 8);
      .cname {
        flex-shrink: 0;
        margin-right: calc(var(--gap) * 4);
      }
    }
    .item-info {
      margin-bottom: calc(var(--gap) * 16);
      .info {
        width: 40%;
      }
    }
    .item-num {
      margin-left: calc(var(--gap) * 4);
      color: var(--g6);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
    }
  }
  &.completed {
    background: var(--white)
      url(https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/completed_bg.png?_t=1635756047325)
      bottom right/105px no-repeat;
    .item-name {
      color: var(--g5);
    }
  }
}
</style>